import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAdditionalChargesRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const additionalChargeCategorySchema = z.object({
  name: z.string(),
  amountUsd: z.number(),
});

const GetAdditionalChargesResponseDtoSchema = z.object({
  /** The three largest categories, biggest first. */
  top: z.array(additionalChargeCategorySchema),
  /**
   * Everything else, biggest first and NOT pre-summed — the chart stacks these
   * into one "Other" bar and still names each segment on hover.
   */
  other: z.array(additionalChargeCategorySchema),
});

export type GetAdditionalChargesRequestDto = z.infer<
  typeof _GetAdditionalChargesRequestDtoSchema
>;

export type GetAdditionalChargesResponseDto = z.infer<
  typeof GetAdditionalChargesResponseDtoSchema
>;

export type AdditionalChargeCategory = z.infer<
  typeof additionalChargeCategorySchema
>;

export const getAdditionalCharges = (
  params: GetAdditionalChargesRequestDto,
  config?: AxiosRequestConfig<GetAdditionalChargesRequestDto>
) =>
  api
    .get('facilities/additional-charges', { params, ...config })
    .then(responseContract(GetAdditionalChargesResponseDtoSchema));
